import React from 'react';

import { changeDateFormat, convertNumberToUSFormat } from '@utils/Util';

/***
 * Shows the Head of Supply Chain approval state of the factory price of a single style.
 * The approve and reject actions live in the margin tab, so this banner is read only.
 */
const FactoryPriceApprovalInfo = ({ quote }) => {
	const status = quote?.factoryPriceApprovalStatus;
	if (!status) return null;

	const formatPrice = (price) => (price || price === 0 ? convertNumberToUSFormat(price) : '-');

	const formatDate = (date) => (date ? changeDateFormat(date, 'YYYY-MM-DD', 'DD MMM, YY') : '');

	const respondedAt = formatDate(quote?.factoryPriceApprovalRespondedAt);

	return (
		<div className="order-cancel-info d-flex align-items-center">
			<div className="from-info pr-2">
				<p className="regular-14 gray_dark_02 mb-1">From </p>
				<p className="regular-14 gray_dark_01">
					{quote?.factoryPriceApprovalRequestedBy || '-'}{' '}
					<span className="gray_dark_02">{formatDate(quote?.factoryPriceApprovalRequestedAt)}</span>
				</p>
			</div>
			<div className="reason pl-3 border-left border-right">
				<p className="regular-14 gray_dark_01 mb-1">Factory price approval request</p>
				{/* The first request has no meaningful previous price, so the change is shown only on a retry. */}
				{quote?.factoryPriceApprovalIsRetry && (
					<p className="regular-14 gray_dark_02 mb-0">
						{formatPrice(quote?.factoryPriceApprovalOldPrice)} →{' '}
						{formatPrice(quote?.factoryPriceApprovalNewPrice)}
					</p>
				)}
			</div>
			<div className="approve-reject-action d-flex flex-column align-items-end pl-4">
				{status === 'PENDING' && (
					<span className="awaiting-approval regular-14 gray_dark_02">Pending</span>
				)}
				{status === 'APPROVED' && (
					<button className="button approved size32">
						<span className="approved-text">Approved</span>
					</button>
				)}
				{status === 'REJECTED' && (
					<button className="button approved rejected size32">
						<span className="approved-text">Rejected</span>
					</button>
				)}
				{status !== 'PENDING' && respondedAt && (
					<span className="responded-at regular-12 gray_dark_02 mt-1">{respondedAt}</span>
				)}
			</div>
		</div>
	);
};

export default FactoryPriceApprovalInfo;
